import {getQS, setTimeoutAsync, observeWindowResize, observeResize} from 'utils/vue/lib/utils'

export {getQS, setTimeoutAsync, observeResize}
export const qs = getQS()

export const randomMinMax = function (min, max) {
  return Math.random() * (max - min) + min
}

export const onWindowResize = (callback) => {
  const width = window.innerWidth
  callback({width})
  observeWindowResize(() => {
    const width = window.innerWidth
    callback({width})
  })
}
